import ConditionType from './ConditionType'

const CrossingCondition: ConditionType = {
  value: 'crossing',
  label: 'Crossing',
  hasRHS: true,
}

export default CrossingCondition
